<dv-dialog-content>
  <div class="image-preview">
    @if (imageUrlResource.isLoading()) {
      <dv-spinner size="md"></dv-spinner>
    }

    @if (imageUrlResource.error()) {
      <div class="image-preview__state image-preview__state--error">
        {{ 'General.ImageLoadFailed' | translate }}
      </div>
    }

    @if (imageSrc(); as src) {
      <img class="image-preview__image" [src]="src" alt="Image preview" />
    }
  </div>

  <dv-button footer-right (click)="onClose()">
    {{ 'General.Close' | translate }}
  </dv-button>
</dv-dialog-content>
